import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { SideNavigation } from '@amzn/awsui-components-console';
import Badge from '@amzn/awsui-components-console/badge';
import Select from '@amzn/awsui-components-console/select';
import { DDF_REGIONS, DEFAULT_REGION, TUTORIAL_URL } from './lib/constants';
import { Box } from '@amzn/awsui-components-console';
import { RegionContext } from './CustomContext';
import { useLabAuth } from './contexts/LabAuthContext';

function SiteNavigation(props) {
    const [activeHref, setActiveHref] = React.useState('#/');
    const { selectedRegion, setSelectedRegion } = useContext(RegionContext);
    const { isLabAdmin } = useLabAuth();
    const navHeader = { text: 'DS2 Device Farm', href: '#/' };

    /*
    comment this out for future use
    const generateNewLabel = (header, content) => {
        return (
            <Box color="text-status-info" display="inline">
                <Popover header={header} size="medium" triggerType="text" content={content} renderWithPortal={true}>
                    <Box color="text-status-info" fontSize="body-s" fontWeight="bold">
                        New
                    </Box>
                </Popover>
            </Box>
        );
    };
    */

    useEffect(() => {
        setActiveHref(window.location.hash);
    }, [window.location.hash]);

    const publicNavItems = [
        {
            type: 'link',
            text: 'Region',
            info: (
                <>
                    <Badge color="green">
                        {selectedRegion.value} ({selectedRegion.labelTag})
                    </Badge>
                    <Box variant="div" padding={{ top: 's' }}>
                        <Select
                            selectedOption={selectedRegion}
                            placeholder="Select region"
                            onChange={({ detail }) => {
                                setSelectedRegion(detail.selectedOption);
                                props.history.push('/');
                                setActiveHref('#/');
                            }}
                            options={DDF_REGIONS.map((region) => {
                                return {
                                    label: region.regionName,
                                    iconName: 'settings',
                                    value: region.regionName,
                                    labelTag: region.regionTag,
                                };
                            })}
                        />
                    </Box>
                </>
            ),
        },
        { type: 'divider' },
        {
            type: 'link',
            text: 'Home',
            href: '#/',
        },
        {
            type: 'link',
            text: 'Device checkout',
            href: '#/device-checkout/home',
        },
        {
            text: 'Device metrics',
            type: 'section',
            items: [
                {
                    type: 'link',
                    text: 'Metadata',
                    href: '#/metrics/metadata',
                },
                {
                    type: 'link',
                    text: 'Analytics',
                    href: '#/metrics/analytics',
                },
            ],
        },
    ];
    const onePOnlyItems = [
        {
            text: 'Home lab management',
            type: 'section',
            items: [
                {
                    type: 'link',
                    text: 'Home lab setup',
                    href: '#/home-lab-management/setup',
                },
                {
                    type: 'link',
                    text: 'Home lab monitor',
                    href: '#/home-lab-management/monitor',
                },
                {
                    type: 'link',
                    text: 'Home lab offboarding',
                    href: '#/home-lab-management/offboarding',
                },
            ],
        },
    ];
    const publicNavItems2 = [
        {
            text: 'Automation',
            type: 'section',
            items: [
                {
                    type: 'link',
                    text: 'Automation setup',
                    href: '#/automation/setup',
                },
                {
                    type: 'link',
                    text: 'Test runs',
                    href: '#/automation/test-runs',
                },
            ],
        },
        {
            text: 'API authentication',
            type: 'section',
            items: [
                {
                    type: 'link',
                    text: 'Personal tokens',
                    href: '#/api-auth/personal-tokens',
                },
                {
                    text: 'Bot accounts',
                    type: 'link',
                    href: '#/api-auth/bot-accounts',
                },
            ],
        },
        {
            text: 'Lab management',
            type: 'section',
            defaultExpanded: true,
            items: [
                { type: 'link', text: 'Labs', href: '#/lab-management/labs' },
                { type: 'link', text: 'Group management', href: '#/lab-management/groups' },
                { type: 'link', text: 'Device config management', href: '#/lab-management/device-configs' },
            ],
        },
    ];
    const tutorial = [
        {
            type: 'link',
            text: 'Tutorial',
            href: TUTORIAL_URL,
            external: true,
        },
    ];
    const officeLabNavItems = [
        {
            text: 'Office lab',
            type: 'section',
            defaultExpanded: true,
            items: [
                { type: 'link', text: 'Management', href: '#/office-lab/management' },
                { type: 'link', text: 'Asset management', href: '#/office-lab/assets' },
            ],
        },
    ];

    const adminNavItems = [
        {
            text: 'Admin management',
            type: 'section',
            defaultExpanded: true,
            items: [{ type: 'link', text: 'Queue and allocations', href: '#/queue-management' }],
        },
    ];

    const incomingNavItems = [
        { type: 'divider' },
        {
            type: 'link',
            text: 'Coming soon...',
            href: '',
        },
        {
            type: 'link',
            text: 'Device management',
            href: '',
        },
        {
            type: 'link',
            text: 'Host management',
            href: '',
        },
    ];

    // If the provided link is empty, do not redirect pages
    function onFollowHandler(event) {
        if (!event.detail.external) {
            event.preventDefault();
            if (event.detail.href) {
                props.history.push(event.detail.href.substring(1));
                setActiveHref(event.detail.href);
            }
        }
    }

    return (
        <>
            <SideNavigation
                activeHref={activeHref}
                items={[
                    ...publicNavItems,
                    ...(props.is1pUser ? onePOnlyItems : []),
                    ...publicNavItems2,
                    ...(isLabAdmin ? officeLabNavItems : []),
                    ...(props.isDdfAdmin ? adminNavItems : []),
                    ...(props.is1pUser ? tutorial : []),
                    ...incomingNavItems,
                ]}
                header={navHeader}
                onFollow={(event) => onFollowHandler(event)}
            />
        </>
    );
}

export default withRouter(SiteNavigation);
